import { Common, color } from '@stockbit/ui';
import PropTypes from 'prop-types';
import user from 'utils/user';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { forwardRef } from 'react';
import Image from 'global/Image';
import useDownloadDesktopApp from 'hooks/useDownloadDesktopApp';
import { DesktopAppDownloadAnalytics } from 'features/download/desktop-analytics';
import IconMenuProfile from 'assets/customIcon/IconMenuProfile';
import IconSettingSubsribe from 'assets/customIcon/IconSettingSubscribe';
import IconSettingRules from 'assets/customIcon/IconSettingRules';
import IconSettingSupport from 'assets/customIcon/IconSettingSupport';
import IconSettingLogout from 'assets/customIcon/IconSettingLogout';
import IconMenuSetting from 'assets/customIcon/IconMenuSetting';
import IconSettingTipjar from 'assets/customIcon/IconSettingTipjar';
import IconCommunity from 'assets/customIcon/IconCommunity';
import { MenuList, MenuListContainer, ImageWrapper } from './styled';

const { Text, IconWrapper } = Common;

const MenuListWithRef = forwardRef(({ href, onClick, children }, ref) => (
  <a href={href} onClick={onClick} ref={ref}>
    {children}
  </a>
));

MenuListWithRef.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

MenuListWithRef.defaultProps = {
  href: '',
};

const ProfileMenuReactNode = (data) => {
  const { download } = useDownloadDesktopApp();
  const router = useRouter();

  const getStyleMenuList = (isDownloadMenu, index) => {
    if (isDownloadMenu) return { display: 'none' };
    if (!isDownloadMenu && index === 3) return { borderBottom: 'none' };
    return {};
  };

  const onClickItem = (e, item) => {
    if (item.type === 'download') {
      e.preventDefault();

      const os = user.getOS();
      const analyticOS = os === 'macOS' ? 'Mac' : os;
      if (os === 'macOS' || os === 'Windows') {
        DesktopAppDownloadAnalytics.onDownloadDesktopApp({
          os: analyticOS,
          source: 'Dropdown Profile',
        });
        download(os.toLowerCase());
        const el = document.getElementById('icon-profile-popover');
        el.click();
      } else {
        router.push('/desktop');
      }
    } else if (item.onClick) item.onClick(e);
  };

  const getSystemRequirementWording = () => {
    const os = user.getOS();
    if (os === 'macOS') return 'For MacOS 12 or above';
    if (os === 'Windows') return 'For Windows 10 or above';
    return '';
  };

  const renderIcon = (logo) => {
    switch (logo) {
      case 'icon-menu_profile':
        return <IconMenuProfile />;
      case 'icon-menu_setting':
        return <IconMenuSetting />;
      case 'icon-setting_tipjar':
        return <IconSettingTipjar />;
      case 'icon-community':
        return <IconCommunity />;
      case 'icon-setting_subscribe':
        return <IconSettingSubsribe />;
      case 'icon-setting_rules':
        return <IconSettingRules />;
      case 'icon-setting_support':
        return <IconSettingSupport />;
      case 'icon-setting_logout':
        return <IconSettingLogout />;
      default:
        return <IconMenuProfile />;
    }
  };

  return user.profileMenu(data).map((menu, index) => {
    const isDownloadMenu = menu[0].type === 'download';
    return (
      <MenuListContainer
        style={getStyleMenuList(isDownloadMenu, index)}
        key={`menu-list-${index + 1}`}
      >
        {menu.map((item) => {
          const { label, logo, url, image, textColor } = item;
          return (
            <Link href={url} passHref key={label}>
              <MenuListWithRef
                href={url}
                onClick={(e) => {
                  onClickItem(e, item);
                }}
              >
                <MenuList key={label}>
                  {logo && (
                    <IconWrapper size="30px">{renderIcon(logo)}</IconWrapper>
                  )}
                  {image && (
                    <ImageWrapper>
                      <Image alt="" src={image} />
                    </ImageWrapper>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Text size="14px" color={textColor || color.highempahis}>
                      {label}
                    </Text>
                    {item.type === 'download' && (
                      <div style={{ color: '#858585', fontSize: 11 }}>
                        {getSystemRequirementWording()}
                      </div>
                    )}
                  </div>
                </MenuList>
              </MenuListWithRef>
            </Link>
          );
        })}
      </MenuListContainer>
    );
  });
};
export default ProfileMenuReactNode;
